import useAxios from "./useAxios.js";
import { useCallback } from "@wordpress/element";

export function useSubmitLead() {
  const [data, execute] = useAxios(
    {
      headers: { "X-WP-Nonce": wpApiSettings.nonce },
      method: "POST",
      url: wpApiSettings.root + "manitoba-leads/v1/leads",
    },
    {
      manual: true,
    }
  );

  return [
    data,
    useCallback(
      function (data) {
        execute({
          data,
        });
      },
      [execute]
    ),
  ];
}
